import {NullableKeys} from '@fl/cmsch-fe-library';

/** Redux-form id for the comprehensive animal-browser filter form. */
export const cabFilterFormName = 'cabFilter';

/** Nullable filter values used by the comprehensive animal-browser search form. */
export type CabFilterFormValues = NullableKeys<{
    breederIds: Array<number>,
    districtCodes: Array<number>,
    farmIds: Array<number>,
    organizationInsIds: Array<number>,
    organizationPtIds: Array<number>,
    organizationCenterInsIds: Array<number>,
    organizationCenterPtIds: Array<number>,
    stableIds: Array<number>,
}>;

/** Default comprehensive animal-browser filter values. */
export const cabInitialFormValues = {
    breederIds: null,
    districtCodes: null,
    farmIds: null,
    organizationInsIds: null,
    organizationPtIds: null,
    organizationCenterInsIds: null,
    organizationCenterPtIds: null,
    stableIds: null,
};
